import { Injectable, PLATFORM_ID, inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { environment } from '../environment/environment';

/**
 * Makes it harder for users to open the browser's developer tools on the portal:
 * blocks F12, Ctrl/Cmd+Shift+I/J/C/K, Ctrl/Cmd+U and the right-click menu.
 *
 * This is a deterrent only. Anyone can still open DevTools from the browser menu,
 * so never rely on it to protect data — the API must enforce all security.
 *
 * Off on localhost so developers can debug, and when `blockDevTools` is false.
 */
@Injectable({ providedIn: 'root' })
export class DevtoolsBlockService {
  private readonly platformId = inject(PLATFORM_ID);
  private started = false;

  start(): void {
    if (this.started || !isPlatformBrowser(this.platformId)) return;
    if ((environment as any).blockDevTools === false) return;

    const host = window.location.hostname;
    if (host === 'localhost' || host === '127.0.0.1' || host === '::1') return;

    this.started = true;
    document.addEventListener('keydown', this.onKeyDown, true);
    document.addEventListener('contextmenu', this.onContextMenu, true);
  }

  private onKeyDown = (event: KeyboardEvent): void => {
    const key = (event.key || '').toLowerCase();
    const ctrlOrCmd = event.ctrlKey || event.metaKey;

    const blocked =
      key === 'f12' ||
      // Ctrl+Shift+I/J/C/K (Windows/Linux), Cmd+Option+I/J/C (Mac)
      (ctrlOrCmd && (event.shiftKey || event.altKey) && ['i', 'j', 'c', 'k'].includes(key)) ||
      // View source
      (ctrlOrCmd && key === 'u');

    if (blocked) {
      event.preventDefault();
      event.stopPropagation();
    }
  };

  private onContextMenu = (event: MouseEvent): void => {
    // Keep the menu in text fields so users can still copy / paste
    const target = event.target as HTMLElement | null;
    if (target?.closest('input, textarea, [contenteditable="true"]')) return;
    event.preventDefault();
  };
}
